import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";
import { Dialog } from "../../utils/confirm-modal";

/**
 * Хадгалаагүй өөрчлөлттэй үед хуудаснаас гарахыг сануулна.
 * Апп нь data router биш (BrowserRouter) тул useBlocker ашиглах боломжгүй — navigator.push/replace-ийг түр боож,
 * reload / tab хаахыг beforeunload-оор барина. Browser-ийн Back товч (popstate) үүнд хамаарахгүй.
 */
export function useUnsavedGuard(active: boolean, message: string) {
  const navigator = useContext(UNSAFE_NavigationContext).navigator as any;

  useEffect(() => {
    if (!active) return undefined;
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);

    const { push, replace } = navigator;
    const restore = () => {
      navigator.push = push;
      navigator.replace = replace;
    };
    const guard = (original: (...args: any[]) => void) => (...args: any[]) => {
      Dialog.confirm(message, (key) => {
        if (key !== "confirm") return;
        restore();
        original.apply(navigator, args);
      });
    };
    navigator.push = guard(push);
    navigator.replace = guard(replace);

    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
      restore();
    };
  }, [active, message, navigator]);
}
